import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import { useRootStore } from '@/lib/providers/RootProvider';
import ScannedProduct from './ScannedProduct';
import { WAREHOUSE_PRODUCT_STOCK_BY_CODE } from './productStock';

const ScannedProductData = () => {
  const [searchParams] = useSearchParams();
  const code = (searchParams.get('code') || '').trim();
  const companyId = useRootStore((state) => state.selectedCompany?.id);
  // The home scanner fetched this from the network a moment ago to decide to come here, and it is
  // the only way in, so the cached answer is current. A reload has no cache and fetches.
  const { data, error, loading } = useQuery(WAREHOUSE_PRODUCT_STOCK_BY_CODE, {
    fetchPolicy: 'cache-first',
    skip: !code || !companyId,
    variables: { companyId, code }
  });

  // RootProvider renders no route before it has a company, so none here means the user has none.
  if (!code || !companyId) return <Navigate to="/" />;
  const products = data?.warehouseProductStockByCode;
  if (!products && loading) return <Spinner />;
  if (!products && error) return <ApiError error={error} />;

  return <ScannedProduct code={code} products={products || []} />;
};

export default ScannedProductData;
